import { FunctionComponent } from 'react';
import { DetailsModalCommon } from '../../../shared';
import { DetailsContent } from '../DetailsContent';

export const DetailsModal: FunctionComponent = () => {
  return <DetailsModalCommon ContentComponent={DetailsContent} />;
};
